/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const DURATION = feature.getSettingValue('DURATION');
    const NAME = `delay_${feature.getID()}`;

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        id: `declare_${NAME}`,
        template: `
let ${NAME} = null;
`,
    });

    const links = project.getNodeLinks(feature, 'delay_start');
    for (let i = 0; i < links.length; i++) {
        const link = links[i];
        const source: BaseNode = project.getFeature(link.getSettingValue('SOURCE_FEATURE')) as BaseNode;
        const sourceParams = source.getPort(link.getSettingValue('SOURCE_PORT'))?.params;
        const duration = project
            .parseCodeExpression(DURATION, sourceParams, TibboDataType.FLOAT);


        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `
${NAME} = setTimeout(delay_interruption_handler_${NAME}, ${duration} * 1000)
`,
        });
    }

    const elapsedLinks = project.getNodeLinks(feature, 'delay_elapsed');
    if (elapsedLinks.length > 0) {
        const link = elapsedLinks[0];

        blocks.push({
            location: 'FUNCTION_DEFINITIONS',
            blockType: BlockType.CODE,
            id: `delay_interruption_handler_${NAME}`,
            template: `
    function delay_interruption_handler_${NAME}() {
        clearTimeout(${NAME});
        ${NAME} = null;
        /****${link.getSourceId()}****/
    }
    `,
        });
    }

    return blocks;
};
